<template>
  <div id="app">
    <div class="main_content">
    <header>
			<div class="container">
				<div class="top_header">
					<ul class="list-unstyled list-inline pull-right">
						<li class="hidden-xs" v-if="userID !== ''">
							<a href="#" @click="logout()">登出</a>
						</li>
						<li class="hidden-xs" v-if="userID !== ''"><a href="/member/consume">會員中心</a></li>
						<li v-if="userID !== ''">歡迎 {{this.userName}}</li>
						<li v-if="userID === ''">
							<span class="glyphicon glyphicon-user" aria-hidden="true"></span>
							<a href="#" data-toggle="modal" data-target=".login_modal">
							登入 / 註冊</a>
						</li>
						<li>
							<button type="button" class="btn btn-default i80_btn" @click="showCartList()">
								購物車(<span v-if="items">{{items.length}}</span>)
							</button>
						</li>
					</ul>
					<ul class="list-unstyled list-inline">
						<li class="hidden-xs">
							<span class="glyphicon glyphicon-earphone" aria-hidden="true"></span>
							<a href="tel:034593159">03-4593159</a>
							<a href="tel:0909413131">0909-413-131</a>
              <a href="#">愛幫您股份有限公司 統編:23882568</a>
						</li>
						<li class="hidden-xs">
							<span class="glyphicon glyphicon-home" aria-hidden="true"></span>
              <a href="https://maps.google.com/?q=台東縣關山鎮德高里永豐10之1號" target="_blank">台東縣關山鎮德高里永豐10之1號</a>
						</li>
						<li><a href="https://www.facebook.com/i80earnyourmoney/">Facebook</a></li>
					</ul>
					<!-- shopping cart list -->
					<div class="cart" v-show="showCart">
							<div class="cart_list" v-show="items !==''">
								<ul class="list-unstyled">
									<li class="item" v-for="(item, index) in items" transition="fade">
										<div class="row">
											<div class="col-sm-5 col-xs-5">
												<figure class="pic">
														<img :src="'https://files.i80.com.tw/images/product/'+item.imageL" class="img-responsive"/>
												</figure>
											</div>
											<div class="col-sm-7  col-xs-7">
												<span>{{ item.price }}x{{ item.quantity }}</span>
												<span class="glyphicon glyphicon-trash pull-right delete"  @click="DELETE_TO_CART(item)"></span>
												<p>{{item.name}}</p>
											</div>
										</div>
									</li>
								</ul>
							</div>
							<router-link v-bind:to="'/cart'" class="checkout pull-right">
									<button type="button" class="btn btn-default i80_btn">結帳去<span class="glyphicon glyphicon-arrow-right"></span></button>
							</router-link>
					</div>
				</div>
			</div>
		</header>
		<nav class="navbar navbar-default navbar-static-top">
			<div class="container">
		  		<div class="navbar-header">
	      			<button type="button" class="navbar-toggle collapsed mobile_menu_btn" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1" aria-expanded="false">
				        <span class="sr-only">Toggle navigation</span>
				        <span class="icon-bar"></span>
				        <span class="icon-bar"></span>
				        <span class="icon-bar"></span>
			      	</button>
			      	<a class="navbar-brand"  id="logo" href="/">
								<h1>i80愛幫您</h1>
			      	</a>
			    </div>
			    <!-- Collect the nav links, forms, and other content for toggling -->
			    <div class="collapse navbar-collapse main_menu" id="bs-example-navbar-collapse-1">
						<ul class="nav navbar-nav navbar-right">
							<li class="visible-xs" v-if="userID !== ''">
								<a href="#" @click="logout()">登出</a>
							</li>
							<li class="visible-xs" v-if="userID !== ''"><a href="/member">會員中心</a></li>
							<li><a href="/news">最新消息</a></li>
							<li class="dropdown">
								<a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">關於我們<span class="caret"></span></a>
									<ul class="dropdown-menu">
										<li><a href="/about">關於i80</a></li>
										<li><a href="/about">我們的會員</a></li>
										<li><a href="/privacy">隱私權政策</a></li>
										<li><a href="/privacy">使用條款</a></li>
									</ul>
							</li>
							<li><a href="/product">購物商城</a></li>
							<li><a href="/store">聯盟店家</a></li>
              <li><a href="/freetrial">立即體驗</a></li>
							<li><a href="/operators">聯盟經營者</a></li>
              <li><a href="/search/product">商品查詢</a></li>
							<hr>
			      </ul>
			    </div><!-- /.navbar-collapse -->
			</div>
		</nav>
    	<router-view></router-view>
    </div>

    <footer>
		<div class="container">
			<div class="row">
				<div class="col-sm-3 col-xs-12">
					<div class="job_box">
						<figure class="img"><img src="/static/images/index/homebottom.png" class="img-responsive"></figure>
						<p class="txt">你想幫助更多的人在網上賺錢嗎？如果你對數位行銷有興趣和熱情，歡迎你加入我們！</p>
						<!-- <a href="/register" class="btn btn-default i80_btn">加入我們</a> -->
					</div>
				</div>
				<div class="col-sm-9 col-xs-12">
					<div class="row">
						<div class="col-sm-4 col-xs-12">
							<div class="about_box">
								<h4 class="title">認識愛幫您</h4>
								<p class="txt">愛幫您是台灣專業聯盟行銷平台。我們提供推廣者至少10%以上的回饋，成效可即時查詢，
								具有自行代理的優質商品外，結合聯盟店家提供客制化服務，我們提供廠商使用成效收費模式，依據消費者實際購物來計算回饋金，
								有效降低您的行銷風險，提升報酬率。</p>
							</div>
						</div>
						<div class="col-sm-8 col-xs-12">
							<div class="row">
								<div class="col-sm-4">
									<h4 class="title">關於我們</h4>
									<ul class="submenu list-unstyled">
									  <li><a href="/about"><span class="glyphicon glyphicon-minus"></span>關於我們</a></li>
										<li><a href="/ourteam"><span class="glyphicon glyphicon-minus"></span>我們的會員</a></li>
										<li><a href="/privacy"><span class="glyphicon glyphicon-minus"></span>隱私權政策</a></li>
										<li><a href="/term"><span class="glyphicon glyphicon-minus"></span>使用條款</a></li>
                    <li><a href="/product"><span class="glyphicon glyphicon-minus"></span>購物商城</a></li>
									</ul>
								</div>

								<div class="col-sm-4">
									<h4 class="title">相關資訊</h4>
									<ul class="submenu list-unstyled">
										<li><a href="/contact"><span class="glyphicon glyphicon-minus"></span>聯絡我們</a></li>
										<li><a href="/faq"><span class="glyphicon glyphicon-minus"></span>FAQ</a></li>
										<li><a href="/store"><span class="glyphicon glyphicon-minus"></span>聯盟商家</a></li>
										<li><a href="/product"><span class="glyphicon glyphicon-minus"></span>產品列表</a></li>
									</ul>
								</div>

								<div class="col-sm-4">
									<h4 class="title">加入Line@</h4>
									<img src="/static/images/index/i80line.png"/>
								</div>

							</div>
						</div>
					</div>
					<div class="line"></div>
					<div class="">
						<ul class="list-unstyled visible-xs">
							<li>
								<span class="glyphicon glyphicon-earphone" aria-hidden="true"></span>
								<a href="tel:034593159">(03)4593-159</a>
								<a href="tel:0909413131">0909-413-131</a>
							</li>
							<li><a href="#"><span class="glyphicon glyphicon-envelope" aria-hidden="true"></span>drwateri80@gmail.com</a></li>
							<li><span class="glyphicon glyphicon-home" aria-hidden="true"></span>台東縣關山鎮德高里永豐10之1號</li>
							<li>Copyright © 2016 愛幫您股份有限公司版權所有 法律顧問「宸穎律師事務所」</li>
						</ul>
						<p class="hidden-xs">Copyright © 2016 愛幫您股份有限公司版權所有 營業人：賴發雲 統一編號：23882568</p>
            <p class="hidden-xs">法律顧問「宸穎律師事務所」</p>
					</div>
				</div>
			</div>
		</div>
	</footer>
	<!-- Small modal -->
	<div class="modal fade login_modal" tabindex="-1" role="dialog" aria-labelledby="gridSystemModalLabel">
		<div class="modal-dialog  modal-sm" role="document">
			<div class="modal-content">
				<div class="modal-header">
					<button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
					<h4 class="modal-title" id="gridSystemModalLabel">註冊 / 登入</h4>
				</div>
				<div class="modal-body">
					<div class="form-group">
						<label for="login_account">帳號(Email)</label>
						<input type="email" class="form-control" id="login_account" placeholder="帳號(Email)" v-model="email">
						(忘記Email可至忘記密碼進行查詢)
					</div>
					<div class="form-group">
						<label for="login_pwd">密碼</label>
						<input type="password" class="form-control" id="login_pwd" placeholder="密碼"  v-model="password">
					</div>
					<div class="text-center">
						<button type="button" class="btn btn-success btn-sm"  @click="login()">登入</button>
						<a href="/forgotpass" class="btn btn-default btn-sm"><small>忘記密碼</small></a>
					</div>
				</div>
				<div class="text-left modal-footer">
				  <!--
					<a href="#" class="pull-right">Facebook</a>
					-->
					<a href="/register" class="btn btn-info btn-sm">一般註冊</a>
				</div>
			</div><!-- /.modal-content -->
		</div><!-- /.modal-dialog -->
	</div><!-- /.modal -->
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
export default {
  name: 'app',
  data () {
    return {
      email: '',
      password: '',
      apiurl: 'https://affiliate.i80.com.tw/',
      showCart: false,
      verified: false
    }
  },
  mounted: function () {
    // let email = this.$cookie.get('email')
    // let password = this.$cookie.get('password')
    // if (email && password) {
    //   this.email = email
    //   this.password = password
    // }
    // console.log('email:' + email)
  },
  methods: {
    ...mapActions([
      'LOGIN',
      'LOGOUT',
      'DELETE_TO_CART'
    ]),
    logout () {
      this.$store.dispatch('LOGOUT').then(() => {
        this.$router.push('/')
      })
    },
    login () {
      let email = this.email
      let password = this.password
      this.$http.post(this.apiurl + 'api/member_login', {
        email: email,
        password: password
      }).then(function (res) {
        let status = res.body.status
        if (status === 200) {
          let data = {
            userId: res.body.id,
            userName: res.body.name,
            userEmail: res.body.email,
            userPhone: res.body.phone,
            userAddress: res.body.address,
            userCash: res.body.cash,
            userCounty: res.body.county,
            userDistrict: res.body.district,
            firstbuy: parseInt(res.body.firstbuy),
            userValid: res.body.valid,
            userStock: res.body.stock,
            token: res.body.token,
            source_from: 'web'
          }
          // this.$cookie.set('email', email)
          // this.$cookie.set('password', password)
          this.$store.dispatch('LOGIN', data).then(() => {
            this.$router.go('/member')
          })
        } else {
          window.alert('您輸入的帳號或密碼錯誤，請重新輸入。')
        }
      }, function () {
        console.log('failed')
      })
    },
    showCartList () {
      if (this.showCart === false) {
        this.showCart = true
      } else {
        this.showCart = false
      }
    }
  },
  computed: {
    ...mapGetters({
      userName: 'getUserName',
      news: 'getNews',
      items: 'getCart',
      userID: 'getUserID'
    })
  }
}
</script>



// WEBPACK FOOTER //
// App.vue?63b0ddb1